<template>
    <div id="homeBox">
        <div class="pad14">
            <el-button type="text"  icon="el-icon-plus" size="medium"  @click="add">新增</el-button>
        </div>
        <el-table
                id="eltable"
                ref="deliverlight"
                :height="tableHeight"
                highlight-current-row
                size="mini"
                :data="tableData"
                border
                style="width: 100%;">
            <el-table-column
                    prop="row"
                    type="index"
                    :label="$t('form_serial_number')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_name"
                    label="装卸分类名称"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_ckname"
                    :label="$t('form_warehouse')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="i_state"
                    label="状态"
                    show-oveflow-tooltip>
                <template slot-scope="scope">
                    <span v-if="scope.row.i_type==0">全部</span>
                    <span v-if="scope.row.i_type==1">散水</span>
                    <span v-if="scope.row.i_type==2">非散水</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="i_state"
                    label="状态"
                    show-oveflow-tooltip>
                <template slot-scope="scope">
                    <span v-if="scope.row.i_state==1">启用</span>
                    <span v-if="scope.row.i_state==0">未启用</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="vc_lruname"
                    label="录入人"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="dt_createTime"
                    label="录入时间"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    label="操作">
                <template slot-scope="scope" >
                    <div>
                        <el-button  type="text" size="mini" @click="edit(scope.row)">编辑</el-button>
<!--                        <el-button style="color:red;"  type="text" size="mini" @click="del(scope.row)">删除</el-button>-->
                        <el-button  type="text" size="mini" @click="openTree(scope.row)">管理产品</el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                class="fr mrr9"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[10, 15, 30]"
                :page-size="pageSize"
                layout="sizes, prev, pager, next"
                :total="pageTotal">
        </el-pagination>
        <div :class="baseerp+'div'">
            <el-dialog :title="treetitle"
                       class="minw840"
                       width="80%"
                       top="30px"
                       v-if="dialogtreeVisibleW"
                       :visible.sync="dialogtreeVisibleW"
                       :modal-append-to-body="false"
                       :close-on-click-modal="false">
                <transfer-tree @choosetree="choosetree" @close="treeClose" @getList="getList" :datatype="datatype" :data="chooseRow"  :pid="chooseRow.i_id" :treeChoooseData="treeChoooseData"></transfer-tree>
            </el-dialog>
            <el-dialog :title="stevedoretitle"
                       class="minw840"
                       width="50%"
                       top="50px"
                       v-if="dialogsteveVisibleW"
                       :visible.sync="dialogsteveVisibleW"
                       :modal-append-to-body="false"
                       :close-on-click-modal="false">
                <add-stevedore :Data="Data" @close="close" @getList="getList"></add-stevedore>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import {baseerp} from "@/utils/baseUrl";
    import * as API from "./api";
    import {mapActions} from "vuex";
    import TransferTree from "./compontents/TransferTree";
    import addStevedore from "./compontents/addStevedore";

    export default{
        name:'stevedore',
        components:{
            TransferTree,
            addStevedore,
        },
        data(){
            return{
                baseerp:'',
                tableHeight:0,//列表高度
                currentPage:1,
                pageSize:15,
                pageTotal:0,
                tableData:[],
                treetitle:'',
                dialogtreeVisibleW:false,
                treeChoooseData:[],
                datatype:'',
                chooseRow:{},
                stevedoretitle:'',
                dialogsteveVisibleW:false,
                Data:{},
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted(){
            //this.selectWarehouse(),
            this.getList();
            this.$nextTick(()=>{
                this.onResize();
            });
            //公共样式
            this.baseerp=baseerp
        },
        beforeDestroy() {
            // window.removeEventListener('resize',this.heightAuto)
        },
        methods:{
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-80
            },
            ...mapActions(["getCurrentMenuId"]),
            //高度
            heightAuto(){
                this.tableHeight = window.innerHeight - document.getElementById('body').getBoundingClientRect().top -48 -36    ;
            },

            /**************/
            openTree(row,type){
                this.chooseRow=row;
                //this.chooseIndex=row.index
                //this.datatype=type;
                this.datatype=0;
                /*if (type==3){
                    this.treetitle='选择产品'
                    this.treeChoooseData=row.pz?row.pz:[]

                }else if (type==4){
                    this.treetitle='选择公司'
                    this.treeChoooseData=row.gs?row.gs:[]

                }else if (type==6){
                    this.treetitle='选择部门/人员'
                    this.treeChoooseData=row.ry?row.ry:[]

                }*/
                this.treetitle='选择产品';
                this.dialogtreeVisibleW=true
            },
            choosetree(val,type){
                // console.log(val,'this.tableData')
                if (type==3){
                    this.tableData[this.chooseIndex].pz=val

                }else if (type==4){
                    this.tableData[this.chooseIndex].gs=val

                }else if (type==6){
                    this.tableData[this.chooseIndex].ry=val
                }
                let text=val.filter(one=>one.flag==0||one.flag==1);
                if(text.length>0) {
                    if (type==3){
                        this.tableData[this.chooseIndex].vc_products=text.map(one=>{
                            return one.label
                        }).join(';')

                    }else if (type==4){
                        this.tableData[this.chooseIndex].vc_companys=text.map(one=>{
                            return one.label
                        }).join(';')
                    }else if (type==6){
                        this.tableData[this.chooseIndex].vc_depts=text.map(one=>{
                            return one.label
                        }).join(';')
                    }
                }else{
                    if (type==3){
                        this.tableData[this.chooseIndex].vc_products=''
                    }else if (type==4){
                        this.tableData[this.chooseIndex].vc_companys=''
                    }else if (type==6){
                        this.tableData[this.chooseIndex].vc_depts=''
                    }
                }

                this.$set(this.tableData,this.chooseRow.index,this.chooseRow)

                this.treeClose();
            },
            treeClose(){
                this.dialogtreeVisibleW=false
            },
            /**************/
            ckchange(val){
                this.ckid=val
                this.ckdata.warehouseId=val
            },
            ckidchange(val){
                this.ckid=val
            },
            //关闭弹框
            close(){
                this.dialogsteveVisibleW=false
            },
            //页面搜索
            Search(){
                this.getList()
                this.currentPage=1
            },
            handleSizeChange(val){
                this.pageSize=val;
                this.currentPage=1;
                this.getList();
            },
            handleCurrentChange(val){
                this.currentPage=val;
                this.getList()
            },
            //列表
            async getList() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    currentPage:this.currentPage,
                    pageSize:this.pageSize,
                }
                let res = await API.zxTypeList(params);
                if (res.code == 1) {
                    this.tableData=res.data;
                    this.pageTotal=res.total;
                    /*this.tableData.forEach(item=>{
                        item.createTime=item.createTime.substring(0,19)
                    })*/
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },

            //仓库下拉
            async selectWarehouse(val) {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id) {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params={
                }
                let res = await API.selectWarehouse(params);
                if (res.code == 1) {
                    this.ckdata = res.data

                    let arr =  res.data;
                    this.ckid=arr[0].warehouseId
                    this.getList()
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            //作废验证
            async beforeRemove() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    id:this.editData.id,
                }
                let res = await API.beforeRemove(params);
                if (res.code == 1) {
                    this.deltitle=res.message
                    this.getList()
                }else {
                    this.$message.error(res.message);
                }
            },
            // 业务配置作废
            async remove() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    id:this.editData.id,
                }
                let res = await API.remove(params);
                if (res.code == 1) {
                    this.getList()
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);

                } else {
                    this.deltitle=res.message
                }
            },
            add(){
                this.stevedoretitle='新增';
                this.Data={};
                /*this.editData={
                    id:0,
                    name:'',
                    mj:0,
                    rl:0,
                    khid:this.ckid,
                    notes:'',
                    createTime:'',
                    lruName:sessionStorage.getItem('lruname'),
                    state:1
                }*/
                this.dialogsteveVisibleW=true
            },
            //编辑
            edit(row){
                this.stevedoretitle='编辑';
                this.Data=row;
                this.Data.i_id=row.i_id;
                this.dialogsteveVisibleW=true;
                // this.getDetails()
            },
            //确认作废
            submitdel(){
                this.remove()
                this.delDialogVisible=false
                this.getList()
            },
            //作废
            del(val){
                this.editData=val
                this.beforeRemove()
                this.delDialogVisible=true
            },
        },
    }

</script>
<style lang="scss" scoped>
    /deep/{
        .minw840 .el-dialog{
            min-width: 840px;
        }
        .el-table .cell{
            padding-right: 2px;
            padding-left: 2px;
        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }

    }
    .pad14{
        padding: 14px;
    }
    .flexcenter{
        min-width: 39.286rem;
        width: 100%;
        height: 2.857rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 0.857rem;
    }
    /deep/{
        .el-table--enable-row-transition{
            /*min-width: 53.571rem !important;*/
        }
        .el-button--text{
            padding: 0 !important;
            margin-left: 0 !important;
            margin-right: 10px;
        }
        .el-tabs__content{
            /*height: 90% !important;*/
            overflow: visible !important;
            height:calc(100% - 0.357rem) !important;
        }
    }
    /deep/.is-leaf .cell .el-checkbox__input{
        display: none;
    }
    .m{
        padding-top: 1.429rem;
    }
    .flexother {
        display: flex;
        /*flex-flow: wrap;*/
        justify-content: space-between;
        align-items: center;
    }
    .fl{
        float: left;
        .el-button--primary{
            color: #efd773;
            background-color:white;
            border: 0;
            text-align: center;
            padding: 0;
            height: 2rem;
            width: 3.286rem;
            margin:0.857rem 0 0 0.714rem;
        }
    }

    .fr{
        float:right;
    }

    .cl{
        clear: both;
    }
    .input{
        width: 14.286rem;
    }
    /*.mrt20{*/
    /*    margin-top: 1.429rem;*/
    /*}*/
    .mrl20{
        margin-left: 1.429rem;
    }
    .mrb20{
        margin-right: 1.429rem;
    }
    .mrr20{
        margin-right: 1.429rem;
    }

    .chooseheader{
        width:100%;
    }

    .choosepage{
        /*min-width: 42.571rem;*/
        width:90%
    }
    .left{
        width: 17.857rem;
    }
</style>